import { AbstractComponent } from "appworks/components/abstract-component";
import { FowlBigWinComponent } from "components/fowl-big-win-component";
import { BigWinFactory } from "slotworks/components/factories/big-win-factory";

export class FowlBigWinFactory extends BigWinFactory {
    public build(): AbstractComponent {
        const bigWin = new FowlBigWinComponent();
        bigWin.countupMode = this.countMode;
        bigWin.upgrade = this.upgrade;
        bigWin.skipTier = this.skipTier;

        if (this.tiers) {
            for (const tier of this.tiers) {
                bigWin.addWinTier(tier);
            }
        }

        return bigWin;
    }
}
